import React, { memo } from 'react'

import CreateTab from 'Pods/ThreeDStudio/Components/ImageAssistantPanel/Components/CreateTab/CreateTab'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

// The Image Generator page: the AI Assistant's Create tab laid out across the whole area
// right of the sidebar, in place of MobileTabBar + MainPanel + ViewerSidebar. Generated
// images open the full-width editor, whose Back control returns here.
function ImageGenerator() {
  const t = useTranslation()
  const resetKey = useThreeDStudioStore(state => state.ui.imageGeneratorResetKey)

  return (
    <section className="image-generator" aria-label={t('sidebar.linkNav.imageGenerator')}>
      <CreateTab key={resetKey} isFullWidth />
    </section>
  )
}

export default memo(ImageGenerator)
